import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

import { APIURLConstantsService } from '../../services/api-url-service/apiurlconstants.service';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';

export class BaseDataService {
  private options: {
    headers?: HttpHeaders,
    observe?: 'body',
    params?: HttpParams,
    reportProgress?: boolean,
    responseType: any,
    withCredentials?: boolean
  };

  public sendMessage(codi: string, msg: string){
    let params = new HttpParams();
    params = params.append('msg', msg);

    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json',
      params: params 
    }

    return this.authHttp.get(APIURLConstantsService._API_BASE_URL + 'sendmessage/' + codi, this.options)
      .pipe(map(response => response || {}));
  }

  public create(data) {
    return this.authHttp.post(APIURLConstantsService._API_BASE_URL + this.urlKeyword, data)
      .pipe(map(response => response || {}));
  }

  public esborrar(tipus, codi){
    if(tipus == 'proposta')
      return this.authHttp.delete<any>(APIURLConstantsService._API_BASE_URL + 'deleteproposal/' + codi)
      .pipe(map(response =>  response || []));
    else
      return this.authHttp.delete<any>(APIURLConstantsService._API_BASE_URL + 'deleteproposalpe/' + codi)
      .pipe(map(response =>  response || []));
  }

  public canviarCodi(codi, nou_codi){
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'recode/' + codi + '/' + nou_codi)
    .pipe(map(response =>  response || []));
  }

  public downloadFile(path,fileName) {
    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'blob'
    }
    return this.authHttp.get<any>("./assets/"+path+"/"+fileName, this.options )
      .subscribe((response: any) => {
        var blob;
        //MIME TYPES acceptats
        if(fileName.indexOf(".odt") != -1)blob = new Blob([response], {type: "application/vnd.oasis.opendocument.text; charset=charset=utf-8"});
        if(fileName.indexOf(".odp") != -1)blob = new Blob([response], {type: "application/vnd.oasis.presentation.; charset=charset=utf-8"});
        if(fileName.indexOf(".ods") != -1)blob = new Blob([response], {type: "application/vnd.oasis.spreadsheet.; charset=charset=utf-8"});
        if(fileName.indexOf(".rar") != -1)blob = new Blob([response], {type: "application/x-rar-compressed; charset=charset=utf-8"});
        if(fileName.indexOf(".zip") != -1)blob = new Blob([response], {type: "application/zip, application/x-zip-compressed, multipart/x-zip; charset=charset=utf-8"});
        if(fileName.indexOf(".pdf") != -1)blob = new Blob([response], {type: "application/pdf; charset=charset=utf-8"});
        if(fileName.indexOf(".doc") != -1 || fileName.indexOf(".docx") != -1)blob = new Blob([response], {type: "application/vnd.ms-word; charset=charset=utf-8"});
        if(fileName.indexOf(".xls") != -1 || fileName.indexOf(".xlsx") != -1)blob = new Blob([response], {type: "application/vnd.ms-excel; charset=charset=utf-8"});
        if(fileName.indexOf(".gif") != -1)blob = new Blob([response], {type: "image/gif; charset=charset=utf-8"});
        if(fileName.indexOf(".jpe") != -1 || fileName.indexOf(".jpg") != -1 || fileName.indexOf(".jpeg") != -1)
                                          blob = new Blob([response], {type: "image/jpeg; charset=charset=utf-8"});
        if(fileName.indexOf(".png") != -1)blob = new Blob([response], {type: "image/png; charset=charset=utf-8"});
        saveAs(blob, fileName);
    });
   }

  public getActive(limit = 10, skip = 0, filters = {}, conds = {}, ordering = {}, exportar = false): Observable<any> {
    let params = new HttpParams();
    params = params.append('limit', limit.toString());
    params = params.append('skip', skip.toString());

    //Gestiona els resultats de les cerques amb OR i AND
    const stringFilters: {} = {};

    for (const key in filters) {
      const f = filters[key];
      if (f && typeof f === 'object') {
        // Cas per a TEXT (Multi-valor amb OR/AND)
        if (f.type === 'text') {
          const op = f.mode === 'ANY' ? 'OR' : 'AND';
          stringFilters[key] = `${op}: ${f.values.join(', ')}`;
        }
        // Cas per a DATES (DATE: start, end)
        else if (f.type === 'date') {
          const start = f.dateStart;
          const end = f.dateEnd;
          stringFilters[key] = (start != null && end != null)?`DATE: ${start}, ${end}`: null;
        }
        // Cas per a NÚMEROS (BETWEEN: min, max)
        else if (f.type === 'value') {
          const min = f.min;
          const max = f.max;
          stringFilters[key] = (min != null && max != null)?`BETWEEN: ${min}, ${max}`: null;
        }
      }
      if (f && typeof f !== 'object') {
        stringFilters[key] = filters[key]
      }

    }
    Object.keys(stringFilters)
      .filter(filter => (stringFilters[filter] === 0 || stringFilters[filter]))
      .forEach(filter => params = params.append(filter, stringFilters[filter].toString().replace(/\+/g,"%2B")));

    Object.keys(conds)
      .filter(cond => (conds[cond] === 0 || conds[cond]))
      .forEach(cond => params = params.append(cond, conds[cond].toString()));

    Object.keys(ordering).filter(field => (ordering[field] === 0 || ordering[field]))
    .forEach(field => params = params.append((ordering[field] === 'ASC' ? 'orderAsc' : 'orderDesc'), field));

    params = params.append('export', exportar.toString());

    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json',
      params: params 
    }

    return this.authHttp.get<any>(encodeURI(APIURLConstantsService._API_BASE_URL + this.urlKeyword), this.options)
    .pipe(map(response => {return response || []}));
  }

  public getFActive(limit = 10, skip = 0, filters = {}, ordering = {}): Observable<any> {
    let params = new HttpParams();
    params = params.append('limit', limit.toString());
    params = params.append('skip', skip.toString());

    Object.keys(filters)
      .filter(filter => (filters[filter] === 0 || filters[filter]))
      .forEach(filter => params = params.append(filter, filters[filter].toString().replace(/\+/g,"%2B")));

    Object.keys(ordering).filter(field => (ordering[field] === 0 || ordering[field]))
    .forEach(field => params = params.append((ordering[field] === 'ASC' ? 'orderAsc' : 'orderDesc'), field));

    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json',
      params: params 
    }

    return this.authHttp.get<any>(encodeURI(APIURLConstantsService._API_BASE_URL + this.urlKeyword + "/invoices"), this.options)
    .pipe(map(response => {return response || []}));
  }

  public getAutocomplete(id: string): Observable<Array<{value: string, text: string}>> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'autocomplete/' + id)
    .pipe(map(response => response || []));
  }

  public getPossibleNewCodes(codi: string): Observable<Array<{codi: string, titol: string}>> {
    let params = new HttpParams();

    params = params.append('codi', codi);

    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json',
      params: params 
    }

    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'proposal/projecteless', this.options)
    .pipe(map(response => {
      return response || [];
    }));
  }

  public getFitxaComanda(codi): Observable<any> {
    let params = new HttpParams();

    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json',
      params: params 
    }

    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'fitxacomanda/'+codi, this.options)
    .pipe(map(response => {
      return response || [];
    }));

  }

  public getClau(clau) {
    return this.authHttp.get(APIURLConstantsService._API_BASE_URL + "clau/" + (clau?clau:''))
      .pipe(map(response => response || {}));
  }

  public get(id: number | string): Observable<JSON> {
    //Per poder crear automaticament el projecte des de la fitxa de propostes => CODI a la url
    let codi = null;
    codi=this.location.path().split('?')[1];
    codi=(codi?codi.split('codi='):[])[1];
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/' + id + (codi?'?codi='+codi:''))
      .pipe(map(response => {
        const projectData: JSON = response || {};
        ['data_aprovacio', 'data_finalitzacio', 'data_pagament_garantia', 'data_signatura'].forEach(key => {
          if (projectData[key]) {
            try {
              const d = new Date(projectData[key]);
              projectData[key] = d.toISOString().slice(0, 10);
            } catch (e) {
              console.log('Received invalid date for ' + key);
              projectData[key] = '';
            }
          }
        });
      return projectData;
    }));
  }

  public getTask(projectId: number, search: Object): Observable<JSON> {
    let params = new HttpParams();

    if (search) {
      ['skip', 'limit'].forEach(key => {
        if (search[key] === 0 || search[key]) {
          params = params.append(key, search[key]);
        }
      });
    }

    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/' + projectId + '/tasks', this.options)
      .pipe(map(response => {
        const projectData: any = response || [];

        this.dateFields.forEach(key => {
          if (projectData[key]) {
            try {
              const d = new Date(projectData[key]);
              projectData[key] = d.toISOString().slice(0, 10);
            } catch (e) {
              console.log('Received invalid date for ' + key);
              projectData[key] = '';
            }
          }
        });
      return projectData.map(item => {
        if (!item.DESCR) {
          item.DESCR = 'Sense descripció';
        }
        return item;
      });
    }));
  }

  public getCollaborators(projectId: number, search?: Object): Observable<any> {
    let params = new HttpParams();

    if (search) {
      ['skip', 'limit'].forEach(key => {
        if (search[key] === 0 || search[key]) {
          params = params.append(key, search[key]);
        }
      });
    }

    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/' + projectId + '/collaborators', this.options)
    .pipe(map(response => {
      const projectData: any = response || [];
      return projectData;
    }));
  }

  public getSocis(projectId: string): Observable<JSON> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/' + projectId + '/socis')
    .pipe(map(response => {
      const projectData: any = response || [];
      return projectData;
    }));
  }

  public getClients(projectId: string): Observable<JSON> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/' + projectId + '/clients')
    .pipe(map(response => {
      const projectData: any = response || [];
      return projectData;
    }));
  }

  public getContactesClient(clientId: string): Observable<JSON> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'clients/' + clientId + '/contactes')
    .pipe(map(response => {
      const projectData: any = response || [];
      return projectData;
    }));
  }

  public getContacts(projectId: number): Observable<JSON> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/' + projectId + '/contacts')
    .pipe(map(response => { return response || []; }));
  }

  public getOwnProjectsTask(): Observable<any> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'hours/' + this.urlKeyword)
    .pipe(map(response => {
      const data = response || [];
      if (Array.isArray(data)) {
        return data.map(item => {
          item.id = item.code;
          return item;
        });
      }
      return data;
    }));
  }

  public createTask(payload: any): Observable<JSON> {
    return this.authHttp.post<any>(APIURLConstantsService._API_BASE_URL + 'hours/' + this.urlKeyword, payload)
    .pipe(map(response => {
      return response || [];
    }));
  }

  public updateTask(taskId: number, payload: any): Observable<JSON> {
    return this.authHttp.put<any>(APIURLConstantsService._API_BASE_URL + 'hours/' + taskId, payload)
    .pipe(map(response => {
      return response || [];
    }));
  }

  public destroyTask(taskId: number): Observable<JSON> {
    return this.authHttp.delete<any>(APIURLConstantsService._API_BASE_URL + 'hours/' + taskId)
    .pipe(map(response => {
      return response || [];
    }));
  };

  public updateContact(projectId: number, payload: any): Observable<JSON> {
    return this.authHttp.put<any>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/' + projectId + '/contacts', payload)
    .pipe(map(response => {
      return response || [];
    }));
  }

  public addContact(projectId: number, payload: any): Observable<JSON> {
    return this.authHttp.post<any>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/' + projectId + '/contacts', payload)
    .pipe(map(response => {
      return response || [];
    }));
  }

  public deleteContact(projectId: number, { id }: any): Observable<JSON> {
    return this.authHttp.delete<any>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/' + projectId + '/contacts/' + id)
    .pipe(map(response => {
      return response || [];
    }));
  }

  public getHourCount(projectId: string): Observable<JSON> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/' + projectId + '/hourCount')
    .pipe(map(response => {
      const hourCount: any = response || [];
      return hourCount;
    }));
  }

  public getHourProj(projectId: string): Observable<JSON> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/' + projectId + '/hourProj')
    .pipe(map(response => {
      const hourProj: any = response.total || [];
      return hourProj;
    }));
  }

  public getStates(esProposta): Observable<Array<string>> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/states/'+(esProposta?0:1))
    .pipe(map(response => {
      const states: any = response || [];
      return states;
    }));
  }
  
  public getTematiques(t1): Observable<Array<string>> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL +'proposal/tematica/'+t1)
      .pipe(map(response => {
        return response || [];
      }));
  }

  public getAmbits(): Observable<Array<string>> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/ambits')
    .pipe(map(response => {
      const ambits: any = response || [];
      return ambits;
    }));
  }

  public getMonedes(): Observable<Array<string>> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/monedes')
    .pipe(map(response => {
      const monedes: any = response || [];
      return monedes;
    }));
  }

  public getTipus(): Observable<Array<string>> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/tipus')
    .pipe(map(response => {
      const tipus: any = response || [];
      return tipus;
    }));
  }

  public getTipusExpressio(): Observable<Array<string>> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/tipusexpressio')
    .pipe(map(response => {
      const tipus: any = response || [];
      return tipus;
    }));
  }

  public getConsorcis(): Observable<Array<string>> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/consorcis')
    .pipe(map(response => {
      const consorcis: any = response || [];
      return consorcis;
    }));
  }

  public getUtes(): Observable<Array<string>> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + '/utes/codisUtes')
    .pipe(map(response => {
      const utes: any = response || [];
      return utes;
    }));
  }

  public getFites(codi_projecte): Observable<Array<string>> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/fites/'+codi_projecte)
    .pipe(map(response => {
      const monedes: any = response || [];
      return monedes;
    }));
  }
 
  public getConceptes(): Observable<Array<string>> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/fconceptes')
    .pipe(map(response => {
      const conceptes: any = response || [];
      return conceptes;
    }));
  }

  public updateAvaluacio(payload: any): Observable<JSON> {
    return this.authHttp.put<any>(APIURLConstantsService._API_BASE_URL + 'avalua/' + payload.codi, payload)
    .pipe(map(response => { return response || [] }));
  }

  public updateData(id: number, newData: any): Observable<string> {
    return this.authHttp.put<any>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/' + id, newData)
      .pipe(map(response => response || {}));
  }

  public updateCollaborators( projectId: number, {id, coordinador, coord_tecnic, status}: {id: string, coordinador: boolean, coord_tecnic: boolean, status: 'active' | 'inactive'}): 
  Observable<string> {
    const newState = {
      personal_id: id,
      coordinador: coordinador,
      coord_tecnic: coord_tecnic,
      status: status
    };

    return this.authHttp.put<string>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/' + projectId + '/collaborators', newState)
    .pipe(map(response => response));
  }

  public updateClientsContactesProject(projectId: string, newData: any): Observable<string> {
    const newState = {'client_id': newData.idClientSoci, 'contacte_id': newData.idContacte};
    return this.authHttp.put(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/' + projectId + '/clients', newState)
    .pipe(map(response => response.toString()));
  }

  public deleteClientsContactesProject(projectId: string, newData: any): Observable<string> {
    return this.authHttp.delete(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/' + projectId + '/clients/' + newData.idClientSoci + '/contactes/' + newData.idContacte)
    .pipe(map(response => response.toString()));
  }

  public updateClientsContactesProposals(projectId: string, newData: any): Observable<string> {
    const newState = {'client_id': newData.idClientSoci, 'contacte_id': newData.idContacte, 'client_final': newData.final};
    return this.authHttp.put(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/' + projectId + '/clients', newState)
    .pipe(map(response => response.toString()));
  }

  public deleteClientsContactesProposals(projectId: string, newData: any): Observable<string> {
    return this.authHttp.delete(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/' + projectId + '/clients/' + newData.idClientSoci + '/contactes/' + newData.idContacte)
    .pipe(map(response => response.toString()));
  }

  public updateSocisContactesProposals(projectId: string, newData: any): Observable<string> {
    const newState = {'soci_id': newData.idClientSoci, 'contacte_id': newData.idContacte, 'perc_participacio': newData.perc_participacio, 'lider': newData.lider};
    return this.authHttp.put(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/' + projectId + '/socis', newState)
    .pipe(map(response => response.toString()));
  }

  public deleteSocisContactesProposals(projectId: string, newData: any): Observable<string> {
    return this.authHttp.delete<any>(APIURLConstantsService._API_BASE_URL + this.urlKeyword + '/' + projectId + '/socis/' + newData.idClientSoci + '/contactes/' + newData.idContacte)
    .pipe(map(response => response.toString()));
  }

  constructor(
    protected authHttp: HttpClient,
    protected urlKeyword,
    private validFilters,
    private validOrdering,
    private dateFields,
    private location: Location
  ) {}
}

@Injectable()
export class ProjectsService extends BaseDataService {
  constructor(authHttp: HttpClient, location: Location) {
    super(authHttp, 'project', [
      'dataCode', 'dataTematica', 'dataTecnic', 'dataEmpresa', 'dataClient', 'dataTitol', 'dataTitolOf',
      'stateActive', 'stateFinished', 'stateCobratNotFinished', 'stateClosed', 'statePaused', 'stateCancelled'
    ], [
      'codi', 'tematica3', 'qui_col·labora', 'data_aprovacio', 'data_finalitzacio', 'pressupost_propi_proj', 'durada_mesos'
    ], [
      'data_aprovacio', 'data_finalitzacio', 'data_pagament_garantia', 'data_signatura'
    ], location );
  }
}

@Injectable()
export class ProposalsService extends BaseDataService {
  constructor(authHttp: HttpClient, location: Location) {
    super(authHttp, 'proposal', [
      'dataCode', 'dataTematica', 'dataTecnic', 'dataEmpresa', 'dataClient', 'dataTitol', 
      'dataTitol', 'stateInProgress', 'statePresented', 'statePresentedReq', 'stateAproved',
      'stateContracted', 'stateNotAccepted', 'stateAbandoned', 'stateNoPresentedtTemps'
    ], [
      'codi', 'empresa', 'data_proposta', 'data_inici_possible', 'pressupost_licitacio', 'durada_mesos'
    ], [
      'data_inici_possible', 'data_proposta'
    ], location);
  }
}

@Injectable()
export class ProposalsPeService extends BaseDataService {
  constructor(authHttp: HttpClient, location: Location) {
    super(authHttp, 'proposalpe', [
      'dataCode', 'dataTematica', 'dataTecnic', 'dataEmpresa', 'dataClient', 'dataTitol', 
      'dataTitol', 'stateInProgress', 'statePresented', 'statePresentedReq', 'stateAproved',
      'stateContracted', 'stateNotAccepted', 'stateAbandoned', 'stateNoPresentedtTemps'
    ], [
      'codi', 'empresa', 'data_proposta', 'data_inici_possible', 'pressupost_licitacio', 'durada_mesos'
    ], [
      'data_inici_possible', 'data_proposta'
    ], location);
  }
}
